import { LoruleRequestConfig } from '@galaxy/lorule-react-commons';
import { callWebUtils, commonHeaders } from './commonApiUtil';
import { EbsResponsibilityType } from './ebsUserApiTypes';

export const getMyEmployeeId = async (config: LoruleRequestConfig) =>
    callWebUtils<number>(config, `/user/me/employeeId`, 'GET', null, commonHeaders);

export const getEbsResponsibilities = async (config: LoruleRequestConfig) =>
    callWebUtils<Array<EbsResponsibilityType>>(config, `/user/resp`, 'GET', null, commonHeaders);
